const RESULT_STATUS_PRESENTATIONS = Object.freeze({
  withdrawn: Object.freeze({
    label: '철회됨',
    helpText: '입력 철회로 무효화된 이력입니다. 현재 결과나 공식 결과로 사용할 수 없습니다.',
    chipClass: 'work-chip is-result-inactive',
  }),
  candidate: Object.freeze({
    label: '후보 결과',
    helpText: '공식 지정 전 검토 중인 결과입니다.',
    chipClass: 'work-chip is-result-candidate',
  }),
  official: Object.freeze({
    label: '공식 결과',
    helpText: '현재 업무의 공식 결과입니다.',
    chipClass: 'work-chip is-result-official',
  }),
  rejected: Object.freeze({
    label: '반려',
    helpText: '검토에서 반려되어 공식 결과로 사용할 수 없습니다.',
    chipClass: 'work-chip is-result-rejected',
  }),
  superseded: Object.freeze({
    label: '대체됨',
    helpText: '새 공식 결과로 대체된 이전 결과입니다.',
    chipClass: 'work-chip is-result-inactive',
  }),
  rolled_back: Object.freeze({
    label: '복구됨',
    helpText: 'rollback으로 복구 이력에 포함된 결과입니다.',
    chipClass: 'work-chip is-result-inactive',
  }),
})

export function isWorkResultStatus(status) {
  return Object.prototype.hasOwnProperty.call(RESULT_STATUS_PRESENTATIONS, status)
}

export function isWithdrawnWorkResult(record = {}) {
  return record?.validity === 'withdrawn' || (record?.withdrawal_id !== undefined && record?.withdrawal_id !== null)
}

export function isWithdrawnWorkRun(run = {}) {
  return isWithdrawnWorkResult(run) ||
    (Array.isArray(run?.outputs) && run.outputs.some(isWithdrawnWorkResult)) ||
    (Array.isArray(run?.run_result?.outputs) && run.run_result.outputs.some(isWithdrawnWorkResult))
}

export function getWorkResultStatusPresentation(status, record = {}) {
  if (isWithdrawnWorkResult(record)) status = 'withdrawn'
  if (isWorkResultStatus(status)) {
    return { status, ...RESULT_STATUS_PRESENTATIONS[status] }
  }
  return {
    status: status || '',
    label: status || '-',
    helpText: '',
    chipClass: 'work-chip is-result-unknown',
  }
}

export function getWorkResultReason(row = {}) {
  const reason = [row.rejection_reason, row.revision_reason, row.reason, row.comment]
    .find(value => typeof value === 'string' && value.trim())
  return reason ? reason.trim() : ''
}
